export default {
  setOverlay: (state,overlay='') => {
    state.overlay.previous = state.overlay.current;
    state.overlay.current = overlay;
  },
  hideNewsletter: (state, store) => {
    state.overlay.current = '';
    store.hide_newsletter = new Date();
  },
  toggleMMenuShop: (state) => {
    state.overlay.mmenu.shop_active = !state.overlay.mmenu.shop_active;
  }
}